import { GatewayApi } from "./base";


export class ServerStatusInterface {
    constructor(
        readonly state: string,
        readonly id: string,
        readonly host: string
    ) {}
}

export interface ServerStatus extends ServerStatusInterface {}


export class SftpApi extends GatewayApi {
    constructor() {
        super('sftp');
    }

    status(): Promise<ServerStatus> {
        return this.invoke('status') ?? {};
    }

    start() {
        this.invoke("start");
    }

    stop() {
        this.invoke("stop");
    }

    list_users() {
        return this.invoke("list_users") ?? {};
    }

    create_user(username: string, password: string) {
        console.log("Create user : ", username, password);
        this.invoke("create_user", { username: username, password: password });
    }

    edit_user(username: string, password: string) {
        this.invoke("edit_user", { username, password });
    }

    delete_user(username: string) {
        this.invoke("delete_user", { username });
    }
};
